var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"custom-transform-class text-none"},[_vm._v("Random TEXT cApitaLization")]),_c('p',{staticClass:"text-break",staticStyle:{"max-width":"4rem"}},[_vm._v(" SUBDERMATOGLYPHIC ")])])
}]

export { render, staticRenderFns }